import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConditionalOption, DataType, DataTypeOption } from '@core/constants/data-types.constants';

@Component({
  selector: 'mfp-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
  @Input() tabs: ConditionalOption<DataType>[] = [];
  @Input() activeTab: DataType = '';
  @Output() activeTabChange = new EventEmitter<any>();
  @Input() showAdd = false;
  @Output() add = new EventEmitter<void>();
  @Input() inactiveTabAdvice = '';

  constructor() {}

  ngOnInit(): void {
    if (!this.tabs.find(s => s.value === this.activeTab)) {
      this.activeTab = this.tabs.length > 0 ? this.tabs[0].value : '';
    }
  }

  setActiveTab(tab: ConditionalOption<DataType>) {
    if (tab.inactive) {
      // TODO: show popup or something
    } else {
      this.activeTab = tab.value;
      this.activeTabChange.emit(tab.value);
    }
  }
}
